import styles from "../styles/page.module.css";
import { ReactComponent as BackIcon } from "../../../assets/icons/arrow-left.svg";
import { Button } from "antd";
import limitStringLength from "../../../utils/limitStringLength";
import { useNavigate } from "react-router-dom";
import HeaderList from "../../../components/HeaderList";
import { ReactComponent as SheetIcon } from "../../../assets/icons/sheet-icon.svg";
import useSurvey from "../../surveys/hooks/useSurvey";
import { useState } from "react";
import { selectUser } from "../../../redux/slices/user";
import { useSelector } from "react-redux";

const StatisticHeader = ({ surveyStatistic, filters }) => {
  const push = useNavigate();
  const { getSurveyExcel } = useSurvey();
  const [loading, setLoading] = useState(false);
  const user = useSelector(selectUser);

  async function downloadExcel() {
    try {
      setLoading(true);
      const response = await getSurveyExcel({
        id_survey: surveyStatistic.id,
        export_type: "all", // Los valores `questions`: solo preguntas, `comments`: solo comentarios, `all`: ambas preguntas y comentarios
        type: "",
        start_date: filters?.start_date || null,
        end_date: filters?.end_date || null,
        phone: "",
        id_user: user.id.toString(),
      });

      const blob = response;

      // Extraemos el filename si queremos

      let filename = `${surveyStatistic?.survey_name ?? "reporte"}.xlsx`;

      // Descarga
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error descargando el Excel:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <header className={styles["statistics-header"]}>
        {/* <div className={styles["statistics-title-container"]}>
          <Button
            onClick={() => push("/ajustes/encuestas")}
            className={styles["statistics-header-btn"]}
            icon={<BackIcon />}
            type="primary"
            style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}

          />
          <h1 title={surveyStatistic?.survey_name}>
            {limitStringLength(surveyStatistic?.survey_name ?? "", 52)}
          </h1>
        </div> */}
        <HeaderList
          title={limitStringLength(surveyStatistic?.survey_name ?? "", 52)}
          back={"/ajustes/encuestas"}
        />

        <div className={styles["statistics-header-actions-container"]}>
          <div className={styles["statistics-header-actions"]}>
            <span>Total Participantes</span>
            <h4>{surveyStatistic?.participants ?? 0}</h4>
          </div>
          <Button
            loading={loading}
            onClick={downloadExcel}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 4,
              height: 40,
            }}
            icon={<SheetIcon />}
            shape="round"
          >
            Exportar
          </Button>
        </div>
      </header>

      <div className={styles["statistics-date"]}>
        <span>Inicio: 01/07/2025</span>
        <span>Finalización: 01/07/2025</span>
      </div>
    </>
  );
};

export default StatisticHeader;
